var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _g3, _g4, _g5, _g6, _g7, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 99,
    viewBox: "0 0 189 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M188.363 54.8948V59.1452C188.363 60.4564 187.797 61.6989 186.803 62.5645L149.089 95.4025C147.675 96.6365 146.039 97.5363 144.308 98.0676V47.5508L188.363 54.8948Z",
    fill: "url(#paint0_linear_59_1757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M144.308 47.5507V98.0675C141.197 99.0359 137.769 98.8388 134.702 97.3905L2.82653 35.0222C1.34402 34.3195 0.401367 32.8284 0.401367 31.1831V26.7527L3.70061 24.1133L144.308 47.5507Z",
    fill: "url(#paint1_linear_59_1757)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M141.763 93.1743C136.176 93.1743 129.543 89.8751 123.125 86.6872C122.036 86.1474 120.948 85.6075 119.868 85.0848L2.26134 29.6919C1.24158 29.212 0.556008 28.2523 0.427467 27.1297C0.307495 26.0242 0.753118 24.9616 1.61863 24.276C2.90405 23.2734 4.59222 22.3993 6.22041 21.5509L6.33182 21.491L48.4335 0.967173C49.5475 0.41016 50.8072 0.110229 52.0583 0.110229C52.9238 0.110229 53.7894 0.247324 54.612 0.521546C72.3422 6.40875 165.218 40.6094 185.844 50.9784C186.993 51.5525 188.192 52.4266 188.381 53.6949C188.569 54.9546 188.141 56.18 187.215 57.0541C176.367 67.346 150.495 91.4175 144.754 92.8315C143.828 93.0543 142.817 93.1743 141.763 93.1743Z",
    fill: "url(#paint2_linear_59_1757)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M140.692 91.469C135.233 91.469 128.746 88.2469 122.473 85.1276C121.41 84.5963 120.348 84.0736 119.285 83.5594L4.3262 29.4177C3.32358 28.9464 2.65516 28.0123 2.53519 26.9069C2.41522 25.8271 2.85225 24.7816 3.70062 24.1218C4.95176 23.1449 6.60566 22.2879 8.19958 21.4567L8.31098 21.3967L49.4614 1.33566C50.5497 0.78722 51.7837 0.49585 53.0006 0.49585C53.849 0.49585 54.6888 0.632962 55.4943 0.898614C72.8303 6.65728 164.043 39.8981 184.207 50.0358C185.33 50.6013 186.075 51.6297 186.255 52.8637C186.435 54.0977 186.024 55.2974 185.116 56.1543C174.507 66.2063 149.227 89.7465 143.614 91.1262C142.714 91.3576 141.729 91.469 140.692 91.469Z",
    fill: "url(#paint3_linear_59_1757)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.6668 1.75568C51.4321 0.873028 53.4802 0.718795 55.3569 1.34436C73.6098 7.41152 163.855 40.3267 184.01 50.4558C186.067 51.4927 186.478 54.2435 184.807 55.8202C175.663 64.4925 149.124 89.301 143.511 90.6722C136.809 92.3603 128 87.2615 119.491 83.1396L4.52304 28.9893C2.73203 28.1495 2.42352 25.6987 3.98316 24.4818C5.22573 23.5049 6.87962 22.6565 8.52495 21.8082L49.6668 1.75568Z",
    fill: "url(#paint4_linear_59_1757)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M150.743 93.8599V89.2496L151.403 88.7526V93.1744L150.743 93.8599Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M171.258 74.5444C171.258 74.7501 171.164 74.9558 171.01 75.0929L167.856 77.8437C167.445 78.2036 166.802 77.9893 166.682 77.4666C166.674 77.4495 166.674 77.4323 166.665 77.4238L166.648 77.3295C166.605 77.081 166.699 76.8239 166.896 76.6525L170.067 73.996C170.384 73.7303 170.813 73.7989 171.061 74.0474C171.061 74.0474 171.053 74.0474 171.061 74.056C171.181 74.1759 171.258 74.3473 171.258 74.5444Z",
    fill: "#BEBFC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M171.069 74.2017C171.069 74.4073 170.975 74.613 170.821 74.7501L167.667 77.5009C167.359 77.7665 166.93 77.7151 166.673 77.4666C166.665 77.4495 166.665 77.4323 166.656 77.4238L166.639 77.3295C166.596 77.081 166.69 76.8239 166.888 76.6525L170.058 73.996C170.375 73.7303 170.804 73.7989 171.052 74.0474C171.052 74.0474 171.044 74.0474 171.052 74.056C171.069 74.0988 171.069 74.1502 171.069 74.2017Z",
    fill: "#110F10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M175.835 71.1766L175.449 71.5879L175.535 69.7798L175.921 69.3599L175.835 71.1766Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M176.734 70.2854L176.349 70.7054L176.434 68.8972L176.82 68.4773L176.734 70.2854Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M177.635 69.4029L177.249 69.8228L177.335 68.0146L177.729 67.5947L177.635 69.4029Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M178.534 68.5201L178.148 68.9399L178.234 67.1318L178.628 66.7119L178.534 68.5201Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M179.443 67.6375L179.049 68.0574L179.135 66.2492L179.529 65.8293L179.443 67.6375Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M180.342 66.7547L179.948 67.166L180.043 65.3579L180.428 64.938L180.342 66.7547Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M181.242 65.8636L180.848 66.2835L180.942 64.4753L181.328 64.0554L181.242 65.8636Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M182.141 64.981L181.756 65.4009L181.842 63.5927L182.227 63.1729L182.141 64.981Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M183.042 64.0983L182.656 64.5182L182.742 62.7101L183.128 62.2902L183.042 64.0983Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M183.941 63.2156L183.556 63.6355L183.641 61.8274L184.027 61.4075L183.941 63.2156Z",
    fill: "#1E201D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M154.514 89.2925L154.103 89.6867L154.283 87.8871L154.694 87.4929L154.514 89.2925Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M155.457 88.4527L155.054 88.8554L155.234 87.0558L155.645 86.6531L155.457 88.4527Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M156.407 87.6214L155.996 88.0156L156.176 86.216L156.587 85.8218L156.407 87.6214Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M157.351 86.7815L156.939 87.1843L157.128 85.3847L157.539 84.9819L157.351 86.7815Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M158.301 85.9503L157.89 86.3446L158.07 84.545L158.481 84.1508L158.301 85.9503Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M159.244 85.1192L158.833 85.5134L159.022 83.7138L159.433 83.311L159.244 85.1192Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M160.195 84.2794L159.784 84.6736L159.964 82.874L160.375 82.4799L160.195 84.2794Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M161.138 83.4481L160.727 83.8422L160.915 82.0427L161.318 81.6399L161.138 83.4481Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M162.089 82.6082L161.678 83.0024L161.858 81.2028L162.269 80.8086L162.089 82.6082Z",
    fill: "#1E201D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M163.031 81.7771L162.62 82.1713L162.8 80.3718L163.211 79.969L163.031 81.7771Z",
    fill: "#1E201D"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M151.687 86.9186L151.832 87.7499C165.595 76.5668 178.432 65.5208 187.395 55.9316C187.721 55.5802 187.91 55.1003 187.85 54.629C187.798 54.192 187.601 54.0034 186.941 55.4174C186.59 56.1801 152.261 87.4671 151.687 86.9186Z",
    fill: "#C0BCCD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_1757",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 184,
    height: 92
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M49.6668 1.75568C51.4321 0.873028 53.4802 0.718795 55.3569 1.34436C73.6098 7.41152 163.855 40.3267 184.01 50.4558C186.067 51.4927 186.478 54.2435 184.807 55.8202C175.663 64.4925 149.124 89.301 143.511 90.6722C136.809 92.3603 128 87.2615 119.491 83.1396L4.52304 28.9893C2.73203 28.1495 2.42352 25.6987 3.98316 24.4818C5.22573 23.5049 6.87962 22.6565 8.52495 21.8082L49.6668 1.75568Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_1757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M65.9063 46.7794C63.3526 44.7141 61.2446 41.9291 60.6361 38.7069C60.1819 36.2732 60.5761 33.6681 59.5992 31.3972C58.5023 28.8264 55.9144 27.2668 54.0034 25.2272C52.0838 23.1877 50.8927 19.7256 52.8551 17.7375C54.6204 15.9465 57.7482 16.6664 59.6935 18.2517C61.6387 19.837 62.967 22.0908 64.9551 23.6333C66.7718 25.0387 69.0942 25.7757 71.3908 25.6728C73.9788 25.5529 76.3868 24.4217 78.8805 23.7104C84.9648 21.9965 91.7518 22.9392 97.1248 26.2641C100.647 28.4408 103.903 31.68 108.034 31.7743C110.279 31.8171 112.421 30.8916 114.641 30.4974C121.051 29.3406 127.409 32.6569 132.637 36.5303C137.872 40.4037 142.757 45.0398 148.91 47.1821C152.826 48.5447 157.505 49.1017 159.862 52.5123C161.533 54.9289 161.498 58.1253 161.001 61.0218C160.513 63.8582 159.45 66.8833 156.974 68.3401C155.757 69.0599 154.334 69.3084 152.938 69.5227C129.954 73.019 106.525 68.64 83.9707 63.0185C81.3056 62.3586 78.572 61.6388 76.361 60.002C75.0842 59.0594 74.0473 57.714 73.516 56.2143C72.9932 54.7404 73.5503 53.5321 73.3446 52.1267C73.1304 50.6699 71.7335 50.4042 70.5253 49.7615C68.9056 48.8875 67.3374 47.9362 65.9063 46.7794Z",
    fill: "url(#paint5_linear_59_1757)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_59_1757",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 184,
    height: 92
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_82__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M49.6668 1.75568C51.4321 0.873028 53.4802 0.718795 55.3569 1.34436C73.6098 7.41152 163.855 40.3267 184.01 50.4558C186.067 51.4927 186.478 54.2435 184.807 55.8202C175.663 64.4925 149.124 89.301 143.511 90.6722C136.809 92.3603 128 87.2615 119.491 83.1396L4.52304 28.9893C2.73203 28.1495 2.42352 25.6987 3.98316 24.4818C5.22573 23.5049 6.87962 22.6565 8.52495 21.8082L49.6668 1.75568Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_59_1757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M156.802 68.7687C154.265 66.2236 152.637 62.9501 150.923 59.7965C149.201 56.643 147.273 53.4723 144.359 51.3813C140.074 48.3049 134.376 48.0478 129.688 45.6312C125.978 43.7203 122.987 40.4381 121.436 36.5648C120.887 35.1851 120.493 33.7111 119.61 32.5286C118.248 30.7033 115.968 29.8806 113.886 28.9637C110.107 27.3098 106.525 25.0303 103.817 21.911C101.109 18.7918 99.3266 14.7641 99.378 10.6337C123.432 10.8308 147.427 16.0153 169.416 25.7758C176.34 28.8437 183.299 32.5543 187.892 38.5786C192.485 44.6029 194.096 53.4808 189.854 59.7622C187.935 62.5987 185.064 64.6297 182.167 66.4464C175.046 70.9282 163.829 75.8214 156.802 68.7687Z",
    fill: "url(#paint6_linear_59_1757)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_59_1757",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 184,
    height: 92
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_82__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M49.6668 1.75568C51.4321 0.873028 53.4802 0.718795 55.3569 1.34436C73.6098 7.41152 163.855 40.3267 184.01 50.4558C186.067 51.4927 186.478 54.2435 184.807 55.8202C175.663 64.4925 149.124 89.301 143.511 90.6722C136.809 92.3603 128 87.2615 119.491 83.1396L4.52304 28.9893C2.73203 28.1495 2.42352 25.6987 3.98316 24.4818C5.22573 23.5049 6.87962 22.6565 8.52495 21.8082L49.6668 1.75568Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_59_1757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M131.436 58.6823C128.394 59.2822 125.369 60.302 122.275 60.1134C117.194 59.8049 112.9 56.3343 109.318 52.718C105.736 49.1017 102.317 45.0569 97.6469 43.026C89.6344 39.5382 80.508 42.8717 71.8186 43.8572C70.4989 44.0115 69.1278 44.0971 67.8595 43.6858C66.3684 43.2059 65.1858 42.0833 63.8833 41.2178C61.4924 39.6239 58.6473 38.8527 55.8109 38.4071C49.9151 37.4816 43.6508 37.9272 38.3464 40.6694C33.0419 43.4116 28.8686 48.6818 28.3887 54.6376C46.8472 60.8076 63.669 71.0052 81.5192 78.7862C94.9989 84.6649 109.036 89.1552 123.038 93.6371C128.951 95.5309 134.881 97.4247 140.982 98.5645C144.659 99.25 148.764 99.5843 151.849 97.4762C153.631 96.2593 154.831 94.374 156.168 92.6773C158.55 89.6523 161.515 87.0643 163.494 83.7651C164.951 81.3314 166.708 77.1837 166.425 74.253C166.16 71.4936 162.663 68.6229 160.709 66.909C155.662 62.4786 149.321 59.5307 142.688 58.5109C138.969 57.9197 135.138 57.9625 131.436 58.6823Z",
    fill: "url(#paint7_linear_59_1757)"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M49.6844 1.72992C51.4497 0.847271 53.4978 0.693038 55.3745 1.31861C73.6274 7.38577 163.872 40.301 184.027 50.43C186.084 51.4669 186.495 54.2177 184.824 55.7945C175.681 64.4668 149.141 89.2753 143.528 90.6464C136.827 92.3346 128.018 87.2358 119.508 83.1139L4.54062 28.9807C2.7496 28.1409 2.4411 25.6901 4.00074 24.4646C5.2433 23.4877 6.8972 22.6394 8.54253 21.791L49.6844 1.72992Z",
    fill: "url(#paint8_linear_59_1757)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_1757",
    x1: 132.337,
    y1: 84.6196,
    x2: 178.363,
    y2: 43.6619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#605F71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#413F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_1757",
    x1: 0.401796,
    y1: 61.3944,
    x2: 144.307,
    y2: 61.3944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0434,
    stopColor: "#33323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    stopColor: "#1E1F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2158,
    stopColor: "#10121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3265,
    stopColor: "#080A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#05080F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7532,
    stopColor: "#070A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8415,
    stopColor: "#0E1018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    stopColor: "#191B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#2A2A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9981,
    stopColor: "#403E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_1757",
    x1: 31.9753,
    y1: 9.38407,
    x2: 192.935,
    y2: 89.6308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#05080F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#413F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_1757",
    x1: 31.9347,
    y1: 6.42042,
    x2: 172.16,
    y2: 81.3483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#05080F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7532,
    stopColor: "#070A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8415,
    stopColor: "#0E1018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    stopColor: "#191B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#2A2A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9981,
    stopColor: "#403E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_1757",
    x1: 2.98011,
    y1: 45.9851,
    x2: 185.84,
    y2: 45.9851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5032,
    stopColor: "#1F1231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#140726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_1757",
    x1: 130.339,
    y1: 60.3594,
    x2: 62.0334,
    y2: 27.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2189,
    stopColor: "#332244",
    stopOpacity: 0.7811
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4318,
    stopColor: "#3F234C",
    stopOpacity: 0.5682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#52245B",
    stopOpacity: 0.3576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8502,
    stopColor: "#6D266F",
    stopOpacity: 0.1498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#862881",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_1757",
    x1: 200.427,
    y1: 49.3531,
    x2: 138.013,
    y2: 41.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4493,
    stopColor: "#5D2563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8005,
    stopColor: "#7B2779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#862881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_1757",
    x1: 145.433,
    y1: 96.6201,
    x2: 73.8123,
    y2: 45.9849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4493,
    stopColor: "#5D2563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8005,
    stopColor: "#7B2779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#862881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_1757",
    x1: 2.99871,
    y1: 45.9657,
    x2: 185.859,
    y2: 45.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0432,
    stopColor: "#7F6985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0911,
    stopColor: "#6D5B74",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1934,
    stopColor: "#4D4155",
    stopOpacity: 0.843
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    stopColor: "#332C3B",
    stopOpacity: 0.7268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4262,
    stopColor: "#1E1C28",
    stopOpacity: 0.5998
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5632,
    stopColor: "#10111A",
    stopOpacity: 0.4565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7286,
    stopColor: "#080A11",
    stopOpacity: 0.2837
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05080F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.a69deda532cd4bb25af250d486a93f99.svg";
export { ForwardRef as ReactComponent };